import { createContext, useContext } from "react";
import User from "@/model/interface/User";

export interface AuthContextType {
  isAuthenticated: boolean;
  authHydrated: boolean;
  user: User | null;
  logout: () => Promise<void>;
  refreshAuthStatus: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
